export default "/images/b3a612694b82fa6db000b0d4c5f373e4.avif";